import React from "react";
import ResponsiveAppBar from "./AppBar";
import Footer from "./Footer";
import Container from "@mui/material/Container";

export function Layout({ children }) {
  let content = (
    <>
      <ResponsiveAppBar />
        <main>{children}</main>
      <footer>
        <Footer />
      </footer>
    </>
  );
  return <>{content}</>;
}
